import { render, staticRenderFns } from "./LeccionE6.vue?vue&type=template&id=4e21d68c&"
import script from "./LeccionE6.vue?vue&type=script&lang=js&"
export * from "./LeccionE6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports